import React from "react";
import { Skeleton } from "@mui/material";
import { Wrapper } from "./styles";

function NewcomersSkeleton() {
  return (
    <Wrapper>
      <Skeleton variant="rectangular" width={300} height={350} />
      <Skeleton variant="rectangular" width={300} height={350} />
      <Skeleton variant="rectangular" width={300} height={350} />
      <Skeleton variant="rectangular" width={300} height={350} />
    </Wrapper>
  );
}

export default NewcomersSkeleton;
